const AUTH_STORAGE_KEY = "auth-storage";

/**
 * Get auth token for API requests.
 * Reads from the same localStorage key used by the auth store (Zustand persist).
 * Shared layer only reads; the auth feature owns writing the token on login.
 */
export function getAuthToken(): string | null {
  try {
    const stored = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored) as {
      state?: { token?: string | null };
    };
    return parsed.state?.token ?? null;
  } catch {
    return null;
  }
}
